module.exports = __webpack_public_path__ + "img/pnb.2ca38659.png";